import ClientId from "data/ClientId";

const parseId = idString => ClientId.is(idString)
    ? idString
    : parseInt(idString, 10);

export default parseId;



// WEBPACK FOOTER //
// ./app/data/util/parseId.js